import elliemaeApi from "./interceptors/elliemaeApi";

/**
 * Fetches city and state locations for a given ZIP code using Encompass EPPS API.
 *
 * @param {string} zip - The ZIP code to look up.
 * @param {string} token - Bearer token for API authorization.
 * @returns {Promise<Array<{ city: string, abbrev: string }>>} A list of location objects with city and state abbrev.
 */
export const getZipLocations = async (zip, token) => {
    if (!zip || zip.length < 5) return [];

    try {
        const response = await elliemaeApi.get(`/epps/v2/lookups/zipcodes/${zip}/locations`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("ZIP lookup failed:", error);
        return [];
    }
};
